import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const urlParams = new URLSearchParams(window.location.search)
const clientId = urlParams.get('clientId')
const companyId = urlParams.get('companyId')
const defaultClientId = (clientId ? parseInt(clientId, 10) : 0)
const defaultCompanyId = (companyId ? parseInt(companyId, 10) : 0)

// to handle state
const state = {
  campaigns: {
    result: [],
    count: 0
  },
  campaignsCounts: {
    allCount: 0,
    draftCount: 0,
    testingCount: 0,
    pendingCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    sentCount: 0
  },
  primaryCampaigns: [],
  subCampaigns: [],
  campaign: {
    summaryDetails: {},
    messageDetails: {},
    history: [],
    audience: {},
    customers: [],
    content: '',
    report: {},
    basicValidation: [],
    inboxPreviewAndForecaster: {},
    dynamicQuery: '',
    countGenerating: false
  },
  message: {
    history: []
  },
  audienceSummary: { counts: null },
  messagingAudienceSummary: { uniquePhones: null, totalCustomers: null },
  gridSelectedCampaign: {},
  messagingGridSelectedCampaign: {},
  isTransactional: false,
  isPrimary: true,
  clientId: defaultClientId,
  companyId: defaultCompanyId,
  environmentName: 'eInsight QA Application',
  accountId: 0,
  loading: 0,
  loadingCustomers: false,
  locale: '',
  dateFormat: null,
  timeFormat: null,
  userEmail: '',
  validationCampaignId: '',
  gridLoaded: false,
  campaignJourney: {},
  campaignTimezoneEnable: {},
  userAccessControl: {},
  transactionalMailingInTestMode: {},
  hasEmailContentApproval: {},
  landingTab: 'CampaignsAll',
  einsightUri: '',
  appConfig: {},
  currentChildTemplateId: 0,
  filtersData: {},
  messagingFiltersData: {},
  SMSMessaging: false,
  WhatsAppMessaging: false,
  messagingCampaigns: {
    result: [],
    count: 0
  },
  messagingCampaignsCounts: {
    allCount: 0,
    draftCount: 0,
    testingCount: 0,
    pendingCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    sentCount: 0
  },
  messagingChannel: 'all',
  b2bCampaignType: 'Consumer',
  emailCampaignType: 'Marketing',
  secondaryCampaignKey: 'Email',
  hasApproverPermission: false,
  oktaToken: '',
  messagingBaseUrl: '',
  messagingGridRowHoverData: null,
  messagingStatistics: [],
  hasSalesCampaign: false
}

export const manageCampaigns = {
  state,
  getters,
  actions,
  mutations
}
